var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container_layout"},[_c('Header',{attrs:{"type":"layout"}}),_c('main',{class:{showAside:!_vm.getAsideStausByRouteMeta}},[_c('Aside'),_c('transition',{attrs:{"name":"app-main","mode":"out-in"}},[_c('router-view')],1)],1),_c('Footer',{attrs:{"type":"layout"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }